import { archivosFetch } from "./fetch";

export const handleDownload = async (documentId: number | string | undefined): Promise<string | null> => {
  try {
    if (!documentId) {
      return "ID du document invalide.";
    }

    const response = await archivosFetch(
      `${process.env.REACT_APP_API_URL}/api/archives/${documentId}/download`
    );

    if (!response.ok) {
      return `Le téléchargement a échoué (erreur ${response.status} : ${response.statusText}).`;
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition");
    let filename = "document";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+?)"?$/);
      if (match) {
        filename = match[1];
      }
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    return null;
  } catch (error) {
    console.error("Download error:", error);
    return `Le téléchargement a échoué : ${error instanceof Error ? error.message : "erreur inconnue"}.`;
  }
};
